import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datum'
})
export class DatumPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let result = null;
    let monthAndYear = false;

    /*if (args != null) {
      (args as string[]).forEach(arg => { 
        if (arg === 'monthAndYear') monthAndYear = true;
      });
    }*/
    if (args != null) {
      if (args === 'monthAndYear') monthAndYear = true;
    }

    if (value == null) {
      result = null;
    }
    else if (monthAndYear) {
      let datum = new Date(value);
      if (isNaN(datum.getTime())) return null; // ungültiges Datum

      // Monat + Jahr extrahieren
      const month = (datum.getMonth() + 1).toString().padStart(2, '0'); // 01..12
      const year = datum.getFullYear();

      result = `${month}/${year}`;
    }
    console.log("DatumPipe result:", result);
    return result;
  }

}
